import IManufacturer from '@/models/vehicle/interfaces/manufacturer.d';
import IRange from '@/models/vehicle/interfaces/range.d';
import IDerivative from '@/models/vehicle/interfaces/derivative.d';
import VehicleStatusType from '@/enums/VehicleStatusType';
import VehicleLevel from '@/enums/VehicleLevel';
import VehicleType from '@/enums/VehicleType';
import IVehicleState from './interfaces/vehicle-state.d';

export default class VehicleState implements IVehicleState {
  public vehicleType: VehicleType = VehicleType.Car;

  public vehicleLevel: VehicleLevel = VehicleLevel.Trim;

  public vehicleStatusType: VehicleStatusType = VehicleStatusType.Initial;

  public currentManufacturer: IManufacturer | null = null;

  public currentRange: IRange | null = null;

  public currentDerivative: IDerivative | null = null;

  public isVehicleDataSet: boolean = false;

  public moduleKey: string = '';

  public averagePercentSaving: number = 0;
}
